import { Box } from "@mui/material";
import { TableSimples } from "../../../../../components/BasicComponents/DisplayDados/TableSimples";
import { formatarDecimalNumber } from "../../../../../helpers/masks";
import { PaperBox } from "../../../../../components/Layout/PaperBox";
import { IDataDashboardComercial } from "../../../../../types/api/comercial/dashboard";
import { Typography } from "@mui/material";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export default function CardGraficoPedidosVenda({
    dataDashboard
}: CardGraficoPedidosVendaProps) {

    return (
        <PaperBox style={{ height: '100%' }} p={2}>
            <Typography variant='h6'>Pedidos de venda</Typography>
            <TableSimples
                headers={[
                    { label: "" },
                    { label: "Hoje", numeric: true },
                    { label: "Últimos 7 dias", numeric: true },
                    { label: "Últimos 30 dias", numeric: true },
                ]}
                rows={[
                    {
                        columns: [
                            { value: "Pedidos emitidos" },
                            { value: dataDashboard?.pedidos_venda.emitidos.pedidos_hoje, numeric: true },
                            { value: dataDashboard?.pedidos_venda.emitidos.pedidos_ultimos_7_dias, numeric: true },
                            { value: dataDashboard?.pedidos_venda.emitidos.pedidos_ultimos_30_dias, numeric: true }
                        ]
                    },
                    {
                        columns: [
                            { value: "Valor total" },
                            { value: formatarDecimalNumber(dataDashboard?.pedidos_venda.emitidos.valor_total_pedidos_hoje), numeric: true },
                            { value: formatarDecimalNumber(dataDashboard?.pedidos_venda.emitidos.valor_total_pedidos_ultimos_7_dias), numeric: true },
                            { value: formatarDecimalNumber(dataDashboard?.pedidos_venda.emitidos.valor_total_pedidos_ultimos_30_dias), numeric: true }
                        ]
                    },
                    {
                        columns: [
                            { value: "Ticket médio" },
                            { value: formatarDecimalNumber(dataDashboard?.pedidos_venda.emitidos.ticket_medio_hoje), numeric: true },
                            { value: formatarDecimalNumber(dataDashboard?.pedidos_venda.emitidos.ticket_medio_ultimos_7_dias), numeric: true },
                            { value: formatarDecimalNumber(dataDashboard?.pedidos_venda.emitidos.ticket_medio_ultimos_30_dias), numeric: true }
                        ]
                    },
                    {
                        columns: [
                            { value: <Box height={24} /> },
                            { value: null },
                            { value: null },
                            { value: null }
                        ]
                    },
                    {
                        columns: [
                            { value: "Pedidos faturados" },
                            { value: dataDashboard?.pedidos_venda.faturados.pedidos_hoje?.toLocaleString('pt-BR'), numeric: true },
                            { value: dataDashboard?.pedidos_venda.faturados.pedidos_ultimos_7_dias?.toLocaleString('pt-BR'), numeric: true },
                            { value: dataDashboard?.pedidos_venda.faturados.pedidos_ultimos_30_dias?.toLocaleString('pt-BR'), numeric: true }
                        ]
                    },
                    {
                        columns: [
                            { value: "Valor total" },
                            { value: formatarDecimalNumber(dataDashboard?.pedidos_venda.faturados.valor_total_pedidos_hoje), numeric: true },
                            { value: formatarDecimalNumber(dataDashboard?.pedidos_venda.faturados.valor_total_pedidos_ultimos_7_dias), numeric: true },
                            { value: formatarDecimalNumber(dataDashboard?.pedidos_venda.faturados.valor_total_pedidos_ultimos_30_dias), numeric: true }
                        ]
                    },
                    {
                        columns: [
                            { value: "Ticket médio" },
                            { value: formatarDecimalNumber(dataDashboard?.pedidos_venda.faturados.ticket_medio_pedidos_hoje), numeric: true },
                            { value: formatarDecimalNumber(dataDashboard?.pedidos_venda.faturados.ticket_medio_pedidos_ultimos_7_dias), numeric: true },
                            { value: formatarDecimalNumber(dataDashboard?.pedidos_venda.faturados.ticket_medio_pedidos_ultimos_30_dias), numeric: true }
                        ]
                    },
                ]}
            />
        </PaperBox>
    )
}
interface CardGraficoPedidosVendaProps {
    dataDashboard: IDataDashboardComercial;
}
